import { usePusherETSTicketsSubscription } from 'gcs-common/components/Tickets/usePusherETSTicketsSubscription';
import useChannelInitialization from 'gcs-common/hooks/useChannelInitialization';
import { getTotalUnreadCount } from 'gcs-common/slices/channels/unreadMessagesSelectors';
import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ChatWorkspace from '../ChatWorkspace/ChatWorkspace';
import { usePusherChatSubscriptions } from './usePusherChatSubscriptions';

function ChatRoot() {
  const unreadMessages = useSelector(getTotalUnreadCount) as number;
  const currentUserId: string = useSelector(getCurrentUserId);

  useEffect(() => {
    // set App Badge on installed PWA, currently available on Chrome and Edge
    if ('setAppBadge' in navigator) {
      void navigator.setAppBadge(unreadMessages);
    }
  }, [unreadMessages]);

  useChannelInitialization();
  usePusherChatSubscriptions();
  usePusherETSTicketsSubscription(currentUserId);

  return <ChatWorkspace />;
}

export default ChatRoot;
